import $ from 'jquery'

const Servers = {
  init: function () {
    $(document).on('click', '.js-pin-server', Servers.pin)
    $(document).on('change', '.js-search-type', Servers.toggleType)
    $(document).on('keyup', '.js-quick-search-activity', Servers.quickSearch)
    $(document).on('autocomplete:selected', '.js-server-jump', Servers.search)
  },

  pin: function () {
    $(this).toggleClass('is-active')
  },

  toggleType: function () {
    $('.js-quick-search').attr('action', $(this).val())

    // Toggle buttons
    const inactiveClass = 'u-btn--secondary'
    const parentClass = '.quick-search_type'

    $('.js-search-type').parents(parentClass).addClass(inactiveClass)
    $(this).parents(parentClass).removeClass(inactiveClass)
  },

  quickSearch: function () {
    const $hintEl = $('.js-quick-search-hint')

    if ($(this).val().length > 0) {
      $hintEl.addClass('is-active')
    } else {
      $hintEl.removeClass('is-active')
    }
  },

  search: function (event, item) {
    window.location.href = item.server_url
  },
}

$(Servers.init)
